var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header"},[_c('IntegrationModal',{attrs:{"code":_vm.code,"integration":_vm.integration},on:{"set-integration":_vm.setIntegration}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }